import clsx from 'clsx'
import { useMemo } from 'react'

import { Text } from '@wartek-id/text-v1'

import { usePenetapanPredikatTableStore } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'

// Default contents
const DEFAULT_TITLE = 'Nama Dipilih'
const DEFAULT_DESCRIPTION =
  'Anda dapat melakukan penetapan untuk banyak nama sekaligus.'
const DEFAULT_ALL_SENT_MESSAGE =
  'Semua Rekomendasi Predikat Kinerja berhasil dikirim ke Pejabat Penilai Kinerja'

type SelectionToolbarProps = {
  className?: string
  isLoading?: boolean
  children?: React.ReactNode
  contents?: {
    title?: string
    description?: string
    allSentMessage?: string
  }
}

export function SelectionToolbar({
  className,
  isLoading = false,
  contents = {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    allSentMessage: DEFAULT_ALL_SENT_MESSAGE,
  },
  children,
}: SelectionToolbarProps) {
  const { selectedItems, initialItems } = usePenetapanPredikatTableStore(
    (store) => ({
      selectedItems: store.selectedItems,
      initialItems: store.initialItems,
    })
  )

  const isAllSent = useMemo(
    () => initialItems.every((item) => item.statusPengiriman === 'SENT'),
    [initialItems]
  )

  if (isAllSent && !isLoading) {
    return (
      <div className={clsx('px-6 py-9 bg-surface-success-subdued', className)}>
        <Text
          variant="body-lg"
          color="success"
          className="!font-semibold text-center"
        >
          {contents.allSentMessage}
        </Text>
      </div>
    )
  }

  const numOfSelected = selectedItems.size

  return (
    <div
      className={clsx(
        'p-6 flex items-center justify-between gap-6 bg-white',
        className
      )}
    >
      <div>
        <Text variant="body-lg" className="!font-bold" as="h3">
          {numOfSelected} {contents.title}
        </Text>
        <Text variant="body" color="subdued">
          {contents.description}
        </Text>
      </div>
      <div className="flex items-center justify-between gap-4">{children}</div>
    </div>
  )
}
